// Version : 1.0.0
// Author : AGALYA

const demandCollectionActionTypes = {
	/** ***************** GET MEMBER LOAN INFO START *********************** */
	GET_DEMAND_LOAN_LIST_START: 'GET_DEMAND_MEMBER_LOAN_LIST_START',
	GET_DEMAND_LOAN_LIST_SUCCESS: 'GET_DEMAND_MEMBER_LOAN_LIST_SUCCESS',
	GET_DEMAND_LOAN_LIST_FAILURE: 'GET_DEMAND_MEMBER_LOAN_LIST_FAILURE',
	GET_DEMAND_LOAN_LIST_RESPONSE_RESET: 'GET_DEMAND_MEMBER_LOAN_LIST_RESPONSE_RESET',
	GET_DEMAND_LOAN_LIST_RESPONSE_CHANGED: 'GET_DEMAND_MEMBER_LOAN_LIST_RESPONSE_CHANGED',
	/** ***************** GET MEMBER LOAN INFO END *********************** */

	/** ***************** UPDATE DEMAND COLLECTION START *********************** */
	UPDATE_DEMAND_COLLECTION_REVERT_START: 'UPDATE_DEMAND_COLLECTION_REVERT_START',
	UPDATE_DEMAND_COLLECTION_REVERT_SUCCESS: 'UPDATE_DEMAND_COLLECTION_REVERT_SUCCESS',
	UPDATE_DEMAND_COLLECTION_REVERT_FAILURE: 'UPDATE_DEMAND_COLLECTION_REVERT_FAILURE',
	UPDATE_DEMAND_COLLECTION_REVERT_RESPONSE_RESET:
		'UPDATE_DEMAND_COLLECTION_REVERT_RESPONSE_RESET',
	UPDATE_DEMAND_COLLECTION_REVERT_RESPONSE_CHANGED:
		'UPDATE_DEMAND_COLLECTION_REVERT_RESPONSE_CHANGED',
	/** ***************** UPDATE DEMAND COLLECTION END *********************** */

	/** ***************** UPDATE THRIFT PAID START *********************** */
	UPDATE_THRIFT_PAID_START: 'UPDATE_THRIFT_PAID_START',
	UPDATE_THRIFT_PAID_SUCCESS: 'UPDATE_THRIFT_PAID_SUCCESS',
	UPDATE_THRIFT_PAID_FAILURE: 'UPDATE_THRIFT_PAID_FAILURE',
	UPDATE_THRIFT_PAID_RESPONSE_RESET: 'UPDATE_THRIFT_PAID_RESPONSE_RESET',
	UPDATE_THRIFT_PAID_RESPONSE_CHANGED: 'UPDATE_THRIFT_PAID_RESPONSE_CHANGED',
	/** ***************** UPDATE THRIFT PAID END *********************** */
};
export default demandCollectionActionTypes;
